<div id="login__wrapper">
    <div id="login" fxLayout="row" fxLayoutAlign="center center">
        <mat-card fxLayout="row" class="card">
            <div>
                {{ 'not_found' | translate }}
            </div>
        </mat-card>
    </div>
</div>